import { send } from 'server';
import { TGetPlayerTagsResponse } from 'js/hooks/socket/types';

export const getPlayerTags = (tagName: string): Promise<TGetPlayerTagsResponse> => send({
    ID: 35547,
    responses: [35548, 35549],
    description: 'Get Player Tags Request',
    tagName
});
